import { SuccessResponse } from './interfaces/success-response.interface';
import { ErrorResponse } from './interfaces/error-response.interface';

export type ResponseStruct<T> = Promise<SuccessResponse<T> | ErrorResponse>;
export { UseCase } from './interfaces/usecase.interface';

export { IMailerService } from './ports/mailer/mailer.service';
export {
  ISendMailOptions,
  Address,
} from './ports/mailer/send-mail.options.interface';

export { AssetShortcode } from './domain/asset-shortcode.enum';
export { FiatShortCode } from './domain/fiat-shortcode.enum';
export { DocumentType } from './domain/document-type.enum';

export { Coin } from './ports/market/market.service';
